import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import {
  APPRAISER_STEP_BUTTON_TRACKING,
  LOCATION_AND_STYLE,
  COLORS_AND_OPTIONS,
  CONTINUE_BUTTON_CLASSNAME,
} from 'site-modules/shared/constants/appraisal/appraisal';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';

export const LocationAndStyleStepContinueBtn = ({
  onClick,
  isLoaded,
  isLoadingColorsAndOptions,
  ctaText,
  areStylesReady = true,
}) => (
  <Button
    type="submit"
    onClick={onClick}
    data-index={COLORS_AND_OPTIONS}
    data-tracking-id={APPRAISER_STEP_BUTTON_TRACKING[LOCATION_AND_STYLE]}
    color="success"
    className={classNames(
      'heading-5 text-white py-0_5 form-button text-transform-none pos-r d-block w-100',
      CONTINUE_BUTTON_CLASSNAME
    )}
    disabled={!isLoaded || isLoadingColorsAndOptions || !areStylesReady}
  >
    {(isLoadingColorsAndOptions || !areStylesReady) && (
      <span className="pe-0_5">
        <Spinner size={14} thickness={1} color="white" />
      </span>
    )}
    {ctaText}
  </Button>
);

LocationAndStyleStepContinueBtn.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isLoadingColorsAndOptions: PropTypes.bool.isRequired,
  ctaText: PropTypes.string.isRequired,
  areStylesReady: PropTypes.bool,
};
